import React from 'react';
import PropTypes from 'prop-types';
import { nest } from 'recompose';
import { setPlanType } from 'lib/tracking';
import { PLAN_DUO_THEMES, PLAN_FAMILY_THEMES, ThemeSet } from 'lib/theme';
import { PlanConsumer, PlanProvider } from 'data/plan/context';
import { PlanType } from 'lib/plans';

/**
 * @deprecated use WithPlanProps instead
 */
export const WithPlanPropType = {
  planType: PropTypes.string.isRequired,
  themes: PropTypes.shape({
    light: PropTypes.string.isRequired,
    dark: PropTypes.string.isRequired,
  }).isRequired,
};

export type WithPlanProps = {
  planType: PlanType;
  themes: ThemeSet;
};

export const DuoProvider = ({ children }: any) => {
  setPlanType('duo');
  return (
    <PlanProvider
      value={{
        planType: 'duo',
        themes: PLAN_DUO_THEMES,
      }}
    >
      {children}
    </PlanProvider>
  );
};

DuoProvider.propTypes = {
  children: PropTypes.node,
};

export const FamilyProvider = ({ children }: any) => {
  setPlanType('family');
  return (
    <PlanProvider
      value={{
        planType: 'family',
        themes: PLAN_FAMILY_THEMES,
      }}
    >
      {children}
    </PlanProvider>
  );
};

FamilyProvider.propTypes = {
  children: PropTypes.node,
};

export const withDuo = (Child: any) => nest(DuoProvider, Child);
export const withFamily = (Child: any) => nest(FamilyProvider, Child);
export const withPlan = (Child: any) => (props: any) => (
  <PlanConsumer>{context => <Child {...context} {...props} />}</PlanConsumer>
);

export default withPlan;
